import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: apiUrl,
});

// For checkout component
export const checkoutOrder = (orderData) => {
  return api.post("/api/checkout", orderData);
};

// For itemContext component
export const fetchProducts = () => {
  return api.get("/api/products");
};

// Firebase signup
export const firebaseSignup = (userData) => {
  return api.post("/users/firebase-signup", userData);
};

export const getProducts = () => {
  return api.get("/api/products");
};

export const getProductDetails = (id) => {
  return api.get(`/api/products/${id}`);
};
